module.exports = __webpack_public_path__ + "img/hone-solution2.6bf49f9b.png";